import axios from 'axios';

export default class Api {
  private apiUrl: string;

  constructor() {
    this.apiUrl = process.env.VUE_APP_APIURL;
  }

  /**
   * Dapatkan data URL api
   *
   * @readonly
   * @type {string}
   * @memberof Api
   */
  public get Url(): string {
    return this.apiUrl;
  }
  
  /**
   * Mengirim request dengan GET
   *
   * @param {string} type
   * @param {*} [params=null]
   * @returns {Promise<any>}
   * @memberof Api
   */
  public getResource(type: string, params: any = null): Promise<any> {
    return new Promise((resolve, reject) => {
      axios.get(this.apiUrl + type, { params: params }).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error.response);
      });
    });
  }

  public postResource(type: string, data: any, isNew: boolean, file?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let options: any = undefined;
      if (file) {
        const fd = new FormData();
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            fd.append(key, data[key]);
          }
        }
        fd.append('file', file);
        data = fd;
      } else {
        options = {
          headers: { 'content-type': 'application/json' }
        }
      }
      
      if (isNew) {
        axios.post(this.apiUrl + type, data, options).then(response => {
          resolve(response.data);
        }).catch(error => {
          reject(error.response);
        });
      } else {
        axios.put(this.apiUrl + type, data, options).then(response => {
          resolve(response.data);
        }).catch(error => {
          reject(error.response);
        });
      }
    });
  }
}